import React from "react";
import { Button } from "@mui/material";
import { useDispatch } from "react-redux";
import { setFirebaseUser } from "../../../../reducers/user";
import auth from "../../../../utils/firebase";
import "./SignOutButton.css";
import { resetAppState } from "../../../../reducers/app";
import { resetDepotState } from "../../../../reducers/depot";

export const SignOutButton = () => {
  const dispatch = useDispatch();
  return (
    <Button
      className="signOutButton"
      variant="outlined"
      onClick={async () => {
        dispatch(setFirebaseUser(null));
        dispatch(resetAppState());
        dispatch(resetDepotState());
        await auth.signOut();
      }}
    >
      Sign Out
    </Button>
  );
};
